import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function MRCProgressModal(_ref) {
  let {
    isOpen,
    heading = "Processing...",
    subheading = "Please hold while we submit your donation.",
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(Transition.Root, {
    show: isOpen,
    as: Fragment,
    children: /*#__PURE__*/_jsxs(Dialog, {
      as: "div",
      "data-testid": "progress-modal",
      className: "relative z-10",
      onClose: () => {
        /* Don't close the dialog when clicking the backdrop */
      },
      children: [/*#__PURE__*/_jsx(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/_jsx("div", {
          className: "fixed inset-0 bg-grey-400 bg-opacity-75 transition-opacity"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "fixed z-10 inset-0 overflow-y-auto",
        children: /*#__PURE__*/_jsx("div", {
          className: "flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0",
          children: /*#__PURE__*/_jsx(Transition.Child, {
            as: Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            enterTo: "opacity-100 translate-y-0 sm:scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            children: /*#__PURE__*/_jsx(Dialog.Panel, {
              className: "relative bg-white rounded-3xl px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-md sm:w-full sm:p-6",
              children: /*#__PURE__*/_jsx("div", {
                className: "sm:flex sm:items-start",
                children: /*#__PURE__*/_jsxs("div", {
                  className: "mt-3 font-sans text-center sm:mt-0 sm:text-left",
                  children: [/*#__PURE__*/_jsx(Dialog.Title, {
                    as: "h3",
                    className: "text-lg font-medium text-grey-500",
                    children: heading
                  }), /*#__PURE__*/_jsx("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/_jsx("p", {
                      className: "text-sm text-grey-400",
                      children: subheading
                    })
                  }), /*#__PURE__*/_jsx("div", {
                    className: "mt-2",
                    children: props.body
                  })]
                })
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx("button", {
        className: "h-0 w-0 overflow-hidden"
      }), children]
    })
  });
}